import { useMutation, useQueryClient } from '@tanstack/react-query'
import { deleteOpportunityTask } from '@/lib'
import { queryKeys } from '@/lib/queryKeys'

interface UseDeleteOpportunityTaskOptions {
  onSuccess?: () => void
  onError?: (error: Error) => void
}

interface DeleteTaskParams {
  opportunityId: number
  taskId: number
}

export function useDeleteOpportunityTask(options: UseDeleteOpportunityTaskOptions = {}) {
  const { onSuccess, onError } = options
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async ({ opportunityId, taskId }: DeleteTaskParams) => {
      return deleteOpportunityTask(opportunityId, taskId)
    },
    onSuccess: (_, variables) => {
      const { opportunityId } = variables
      // オポチュニティ詳細用
      queryClient.invalidateQueries({ queryKey: queryKeys.opportunity.tasks(opportunityId) })
      // 担当タスク一覧用
      queryClient.invalidateQueries({ queryKey: queryKeys.myTasks })
      onSuccess?.()
    },
    onError: (error: Error) => {
      onError?.(error)
    },
  })
}
